import React, { createElement, type ComponentType } from 'react';
import BuildsQuickStatsSection from '../BuildsQuickStatsSection/BuildsQuickStatsSection';
import BuildsAlternativeTalentTreeBuildsSection from '../BuildsAlternativeTalentTreeBuildsSection/BuildsAlternativeTalentTreeBuildsSection';
import BuildsBestConsumablesSection from '../BuildsBestConsumablesSection/BuildsBestConsumablesSection';
import BuildsBestEnchantsSection from '../BuildsBestEnchantsSection/BuildsBestEnchantsSection';
import BuildsBestInSlotGearSection from '../BuildsBestInSlotGearSection/BuildsBestInSlotGearSection';
import BuildsConsumableTablesSection from '../BuildsConsumableTablesSection/BuildsConsumableTablesSection';
import BuildsEmbellishmentsSection from '../BuildsEmbellishmentsSection/BuildsEmbellishmentsSection';
import BuildsSeasonalGemsSection from '../BuildsSeasonalGemsSection/BuildsSeasonalGemsSection';
import BuildsEnchantTablesSection from '../BuildsEnchantTablesSection/BuildsEnchantTablesSection';
import BuildsGearTablesSection from '../BuildsGearTablesSection/BuildsGearTablesSection';
import BuildsPopularTalentsSection from '../BuildsPopularTalentsSection/BuildsPopularTalentsSection';
import BuildsPrimaryGemsSection from '../BuildsPrimaryGemsSection/BuildsPrimaryGemsSection';
import BuildsSecondaryGemsSection from '../BuildsSecondaryGemsSection/BuildsSecondaryGemsSection';
import BuildsStatPrioritySection from '../BuildsStatPrioritySection/BuildsStatPrioritySection';
import BuildsTalentTreeBuildSection from '../BuildsTalentTreeBuildSection/BuildsTalentTreeBuildSection';
import BuildsTierSetSection from '../BuildsTierSetSection/BuildsTierSetSection';
import BuildsTrinketCombosSection from '../BuildsTrinketCombosSection/BuildsTrinketCombosSection';
import BuildsTrinketsSection from '../BuildsTrinketsSection/BuildsTrinketsSection';
import BuildsBestRunesSection from '@resources/js/components/BuildsBestRunesSection/BuildsBestRunesSection';
import BuildsCraftedGearStatsSection from '@resources/js/components/BuildsCraftedGearStatsSection/BuildsCraftedGearStatsSection';
import BuildsRuneTablesSection from '@resources/js/components/BuildsRuneTablesSection/BuildsRuneTablesSection';
import BuildsPartneredGuideSection from '@resources/js/components/BuildsPartneredGuideSection/BuildsPartneredGuideSection';
import BuildsCraftedGearSection from '@resources/js/components/BuildsCraftedGearSection/BuildsCraftedGearSection';
import { LinkWrapper } from '@resources/js/components/LinkWrapper/LinkWrapper';
import BuildsSeasonalVendorItemsSection from '../BuildsSeasonalVendorItemsSection/BuildsSeasonalVendorItemsSection';
import BuildsHeroTalentsSection from '@resources/js/components/BuildsHeroTalentsSection/BuildsHeroTalentsSection';
import BuildsOpenerSection from '../BuildsOpenerSection/BuildsOpenerSection';
import BuildsCooldownsSection from '@resources/js/components/BuildsCooldownsSection/BuildsCooldownsSection';
import BuildsThroughputSection from '@resources/js/components/BuildsThroughputSection/BuildsThroughputSection';
import BuildsRotationSampleSection from '@resources/js/components/BuildsRotationSampleSection/BuildsRotationSampleSection';
import BuildsRotationIntroSection from '@resources/js/components/BuildsRotationIntroSection/BuildsRotationIntroSection';
import BuildsRotationFacetsSection from '@resources/js/components/BuildsRotationFacetsSection/BuildsRotationFacetsSection';

export type BuildsSectionComponentViewModel = {
  component: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props: any;
  navigationId: string | null;
  LinkWrapper: LinkWrapper;
};

export default function BuildsSectionComponent({
  component,
  props,
  navigationId,
  LinkWrapper,
}: BuildsSectionComponentViewModel): JSX.Element | null {
  const componentType = componentTypeFromString(component);

  if (!componentType) {
    return null;
  }

  return (
    <div
      className='builds-section-component'
      id={navigationId ? navigationId : undefined}
    >
      {createElement(componentType, {
        ...props,
        LinkWrapper,
      })}
    </div>
  );
}

function componentTypeFromString(
  component: string
): ComponentType<never> | null {
  switch (component) {
    case 'BuildsCraftedGearStatsSection':
      return BuildsCraftedGearStatsSection;
    case 'BuildsAlternativeTalentTreeBuildsSection':
      return BuildsAlternativeTalentTreeBuildsSection;
    case 'BuildsBestConsumablesSection':
      return BuildsBestConsumablesSection;
    case 'BuildsBestEnchantsSection':
      return BuildsBestEnchantsSection;
    case 'BuildsBestInSlotGearSection':
      return BuildsBestInSlotGearSection;
    case 'BuildsConsumableTablesSection':
      return BuildsConsumableTablesSection;
    case 'BuildsEmbellishmentsSection':
      return BuildsEmbellishmentsSection;
    case 'BuildsSeasonalGemsSection':
      return BuildsSeasonalGemsSection;
    case 'BuildsEnchantTablesSection':
      return BuildsEnchantTablesSection;
    case 'BuildsGearTablesSection':
      return BuildsGearTablesSection;
    case 'BuildsPopularTalentsSection':
      return BuildsPopularTalentsSection;
    case 'BuildsPrimaryGemsSection':
      return BuildsPrimaryGemsSection;
    case 'BuildsQuickStatsSection':
      return BuildsQuickStatsSection;
    case 'BuildsSecondaryGemsSection':
      return BuildsSecondaryGemsSection;
    case 'BuildsStatPrioritySection':
      return BuildsStatPrioritySection;
    case 'BuildsTalentTreeBuildSection':
      return BuildsTalentTreeBuildSection;
    case 'BuildsTierSetSection':
      return BuildsTierSetSection;
    case 'BuildsTrinketCombosSection':
      return BuildsTrinketCombosSection;
    case 'BuildsTrinketsSection':
      return BuildsTrinketsSection;
    case 'BuildsBestRunesSection':
      return BuildsBestRunesSection;
    case 'BuildsRuneTablesSection':
      return BuildsRuneTablesSection;
    case 'BuildsPartneredGuideSection':
      return BuildsPartneredGuideSection;
    case 'BuildsCraftedGearSection':
      return BuildsCraftedGearSection;
    case 'BuildsSeasonalVendorItemsSection':
      return BuildsSeasonalVendorItemsSection;
    case 'BuildsHeroTalentsSection':
      return BuildsHeroTalentsSection;
    case 'BuildsOpenerSection':
      return BuildsOpenerSection;
    case 'BuildsCooldownsSection':
      return BuildsCooldownsSection;
    case 'BuildsThroughputSection':
      return BuildsThroughputSection;
    case 'BuildsRotationSampleSection':
      return BuildsRotationSampleSection;
    case 'BuildsRotationIntroSection':
      return BuildsRotationIntroSection;
    case 'BuildsRotationFacetsSection':
      return BuildsRotationFacetsSection;
    default:
      return null;
  }
}
